import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password.component';

const routes: Routes = [
  {
    path: 'reset-password/:token/:hash',
    component: ResetPasswordComponent,
    data: {
      title: 'reset-password',
      authentication: false,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ResetPasswordRoutingModule {}
